/**
 * 通用js方法封装处理
 * Copyright (c) 2022 datahome
 */

// 日期格式化
export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

// 表单重置
export function resetForm(refName) {
  if (this.$refs[refName]) {
    this.$refs[refName].resetFields();
  }
}

// 添加日期范围
export function addDateRange(params, dateRange, propName) {
  let search = params;
  search.params = typeof (search.params) === 'object' && search.params !== null && !Array.isArray(search.params) ? search.params : {};
  dateRange = Array.isArray(dateRange) ? dateRange : [];
  if (typeof (propName) === 'undefined') {
    search.params['beginTime'] = dateRange[0];
    search.params['endTime'] = dateRange[1];
  } else {
    search.params['begin' + propName] = dateRange[0];
    search.params['end' + propName] = dateRange[1];
  }
  return search;
}

/**
 * 回显数据字典
 * @param {*} datas 字典表
 * @param {*} value 数据
 * @param {*} key 字典中的key值
 */
export function selectDictLabel(datas, value, key) {
  let config = {
    key: key || "code"
  }
  var actions = [];
  datas.map((item) => {
    if (item[config.key] == ("" + value)) {
      actions.push(item.name);
      return true;
    }
  })
  return actions.join("");
}

/**
 * 根据所在区id筛选出对应街道列表
 * @param {*} datas 字典表
 * @param {*} value 数据
 * @param {*} key 字典中的key值
 */
export function filterStreetByDistrictId(datas, value, key) {
  let config = {
    key: key || "sys_dic_district_id"
  }
  return datas.filter(item => item[config.key] == value);
}

// 多选数据解析成数组
export function handleStringSplitArray(value, mark) {
  let config = {
    mark: mark || ","
  };
  if (value) {
    return value.split(config.mark);
  }
  return "";
}

// 处理数组组成字符串
export function handleArrayJoinString(arr, mark) {
  let config = {
    mark: mark || ","
  };
  if (Array.isArray(arr) && arr.length) {
    return arr.join(config.mark);
  }
  return "";
}

// 字符串格式化(%s)
export function sprintf(str) {
  var args = arguments, flag = true, i = 1;
  str = str.replace(/%s/g, function () {
    var arg = args[i++];
    if (typeof arg === 'undefined') {
      flag = false;
      return '';
    }
    return arg;
  });
  return flag ? str : '';
}

// 转换字符串，undefined,null等转化为""
export function praseStrEmpty(str) {
  if (!str || str == "undefined" || str == "null") {
    return "";
  }
  return str;
}

// 数据合并
export function mergeRecursive(source, target) {
  for (var p in target) {
    try {
      if (target[p].constructor == Object) {
        source[p] = mergeRecursive(source[p], target[p]);
      } else {
        source[p] = target[p];
      }
    } catch (e) {
      source[p] = target[p];
    }
  }
  return source;
};

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function handleTree(data, id, parentId, children) {
  let config = {
    id: id || 'id',
    parentId: parentId || 'parentId',
    childrenList: children || 'children'
  };

  var childrenListMap = {};
  var nodeIds = {};
  var tree = [];

  for (let d of data) {
    let parentId = d[config.parentId];
    if (childrenListMap[parentId] == null) {
      childrenListMap[parentId] = [];
    }
    nodeIds[d[config.id]] = d;
    childrenListMap[parentId].push(d);
  }

  for (let d of data) {
    let parentId = d[config.parentId];
    if (nodeIds[parentId] == null) {
      tree.push(d);
    }
  }

  for (let t of tree) {
    adaptToChildrenList(t);
  }

  function adaptToChildrenList(o) {
    if (childrenListMap[o[config.id]] !== null) {
      o[config.childrenList] = childrenListMap[o[config.id]];
    }
    if (o[config.childrenList]) {
      for (let c of o[config.childrenList]) {
        adaptToChildrenList(c);
      }
    }
  }
  return tree;
}

/**
 * 对象二级属性，合并一级属性，成为新的一级属性
 * @param {*} data 数据源
 */
export function handleObject(data) {
  let newObject = {};
  for (let d in data) {
    let childObject = data[d];
    for (let child of Object.keys(childObject)) {
      newObject[d + "." + child] = childObject[child];
    }
  }
  return newObject;
}

// 判断数据类型
export const getObjType = obj => {
  var toString = Object.prototype.toString;
  var map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object'
  };
  if (obj instanceof Element) {
    return 'element';
  }
  return map[toString.call(obj)];
};

/**
 * 对象深拷贝
 */
export const deepClone = data => {
  var type = getObjType(data);
  var obj;
  if (type === 'array') obj = [];
  else if (type === 'object') obj = {};
  else return data;
  if (type === 'array') {
    for (var i = 0, len = data.length; i < len; i++) {
      data[i] = (() => {
        if (data[i] === 0) {
          return data[i];
        }
        return data[i];
      })();
      if (data[i]) {
        delete data[i].$parent;
      }
      obj.push(deepClone(data[i]));
    }
  } else if (type === 'object') {
    for (var key in data) {
      if (data) {
        delete data.$parent;
      }
      obj[key] = deepClone(data[key]);
    }
  }
  return obj;
};

// 处理对象的元素值为数组时，处理成字符串
export function handleQueryType(query) {
  let lastQuery = {};
  for (let i in query) {
    let value = query[i];
    if (Object.prototype.toString.call(value) == "[object Array]") {
      lastQuery[i] = value.length > 0 ? value.join(",") : undefined;
    } else {
      lastQuery[i] = value;
    }
  }
  return lastQuery;
}

/**
 * 构造树型结构路由 -- 项目自定路由参数替换
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function handleRouterTree(data, id, parentId, children) {
  let config = {
    id: id || 'id',
    parentId: parentId || 'parentId',
    childrenList: children || 'children'
  };

  var childrenListMap = {};
  var nodeIds = {};
  var tree = [];

  for (let d of data) {
    let parentId = d[config.parentId];
    if (childrenListMap[parentId] == null) {
      childrenListMap[parentId] = [];
    }
    nodeIds[d[config.id]] = d;
    childrenListMap[parentId].push(d);
  }

  for (let d of data) {
    let parentId = d[config.parentId];
    if (nodeIds[parentId] == null) {
      tree.push(d);
    }
  }

  for (let t of tree) {
    adaptToChildrenList(t);
  }

  function adaptToChildrenList(o) {
    if (childrenListMap[o[config.id]] !== null) {
      o[config.childrenList] = childrenListMap[o[config.id]];
    }
    if (o[config.childrenList]) {
      for (let c of o[config.childrenList]) {
        adaptToChildrenList(c);
      }
    }
  }
  return tree;
}


/**
 * 校验选择框，单选框字典是否停用
 * @param {*} val 选中值
 * @param {*} list 字典列表
 * @param {*} key 比对的字典key
 * status_active 1为正常，2为停用
 */
export function checkDisabledOption(val, list, key) {
  let config = {
    key: key || "code"
  };
  // 多选
  if (Array.isArray(val)) {
    let successArr = [], errorArr = [];
    val.length && val.map(item => {
      let matchInfo = list.find(elem => elem[config.key] == item);
      if (matchInfo && matchInfo.status_active !== "1") {
        errorArr.push(`${matchInfo.name}`);
      } else {
        successArr.push(item);
      }
    })
    if (errorArr.length) {
      this.$message.error(errorArr.join("、") + " 选项已停用！");
    }
    return successArr;
  }
  // 单选
  if (typeof val === "string" && val) {
    let successText = "";
    list.map(item => {
      if (item[config.key] == val) {
        if (item.status_active !== "1") {
          this.$message.error("【" + item.name + "】选项已停用！");
          successText = "";
        } else {
          successText = val;
        }
      }
    })
    return successText;
  }
}